var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":_vm.paymentColor}},[_vm._v(" "+_vm._s(_vm.paymentIcon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }